import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../components/grid-container/GridContainer"
import { UiButtonPrimary } from "../../_uiMocks/components/form/UiButton"
import Logo from "../../../styles/img/sb-logo.png"
import { UiLoginContainer, UiLoginPageLogo, UiLoginOptions } from "../../_uiMocks/components/header/UiTopNavElements"


export default function LandingPage(props) {


    return (
        <>
            <UiLoginContainer>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="6">
                        <UiLoginPageLogo Logo={Logo} />
                    </UiCol>
                    <UiCol lg="6" className="sb-login-option">
                        <UiLoginOptions />
                    </UiCol>
                </UiRowContainer>
            </UiLoginContainer>
        </>
    )
}
